<template>
  <div class="hvh-relative">
    <hvh-scroll-overlay style="height: 100%" title="Use ctrl + scroll to zoom the map">
      <HvhMapBox
        :map-options="mapOptions"
        :selectedStates="selectedStates"
        @map-created="mapCreated"
        @[circleSelectedEvent]="$emit(circleSelectedEvent, $event)"
        @[rectangleSelectedEvent]="$emit(rectangleSelectedEvent, $event)"
        @[stateSelectedEvent]="$emit('state-selected', $event)"
        accessToken="pk.eyJ1Ijoic2ltdW5vdmljLW1hcmtvIiwiYSI6ImNraGV6a3BzajBrcXMydGw2Z2ZpdjV6aXQifQ.ic88ynK5syy6_jyOU7SeFw"
        ref="mapBox"
      />
    </hvh-scroll-overlay>
    <loader v-if="isFiltering" />
  </div>
</template>

<script>
import { Debouncer, hashCode } from '../../../libraries/common';
import HvhMapBox from '../../charts/HvhMapBox.vue';
export default {
  components: { HvhMapBox },
  props: ['name', 'filterObject', 'mapOptions', 'debounce', 'isFiltering', 'selectedStates',],
  data(self) {
    return {
      debouncer: new Debouncer(self.debounce || 2000),
    };
  },
  methods: {
    mapCreated(map, mapboxgl, drawControl) {
      this.map = map;

      var emitViewBox = () => {
        var box = this.map.getBounds();
        this.$emit('view-box', {
          neLngLat: [box._ne.lng, box._ne.lat],
          swLngLat: [box._sw.lng, box._sw.lat],
          center: this.map.getCenter().toArray(),
          zoom: this.map.getZoom(),
        });
      };

      this.map.on('zoom', emitViewBox);
      this.map.on('move', emitViewBox);
      this.$emit('map-created', map, mapboxgl, drawControl);

      this.map.dragRotate.disable();
      this.map.touchZoomRotate.disableRotation();
    },
    removeDrawings() {
      this.$refs.mapBox.removeDrawings()
    },
    removeStates() {
      this.$refs.mapBox.removeStates()
    },
  },
  watch: {
    filterHash() {
      this.debouncer.clear().push(() => this.$emit('refresh-data', this.map, this.filterObject));
    },
  },
  computed: {
    filterHash() {
      return hashCode(this.filterObject || {});
    },
    circleSelectedEvent() {
      return this.$listeners['circle-selected'] ? 'circle-selected' : null;
    },
    rectangleSelectedEvent() {
      return this.$listeners['rectangle-selected'] ? 'rectangle-selected' : null;
    },
    stateSelectedEvent() {
      return this.$listeners['state-selected'] ? 'state-selected' : null;
    }
  }
}
</script>

